import { render, staticRenderFns } from "./TransactionTable.vue?vue&type=template&id=650aa92a&scoped=true"
import script from "./TransactionTable.vue?vue&type=script&lang=js"
export * from "./TransactionTable.vue?vue&type=script&lang=js"
import style0 from "./TransactionTable.vue?vue&type=style&index=0&id=650aa92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650aa92a",
  null
  
)

export default component.exports